<template>
  <div
    class="modal fade"
    id="margin_modal"
    tabindex="-1"
    aria-hidden="true"
    ref="addMarkupModalRef"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-550px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_add_customer_header">
          <!--begin::Modal title-->
          <h2 class="fw-bolder">กำหนดกำไร</h2>
          <!--end::Modal title-->

          <!--begin::Close-->
          <div
            id="kt_modal_add_customer_close"
            @click="hide"
            class="btn btn-icon btn-sm btn-active-icon-primary"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <el-form :model="formModel" :rules="rules" ref="markupForm">
          <div class="modal-body py-10 px-lg-17">
            <!--begin::Scroll-->
            <div
              class="scroll-y me-n7 pe-7"
              id="kt_modal_add_customer_scroll"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: false, lg: true}"
              data-kt-scroll-max-height="auto"
              data-kt-scroll-dependencies="#kt_modal_add_customer_header"
              data-kt-scroll-wrappers="#kt_modal_add_customer_scroll"
              data-kt-scroll-offset="300px"
            >
              <div class="row g-9 mb-7">
                <!--begin::Col-->
                <div class="col-md-6 fv-row">
                  <!--begin::Label-->
                  <label class="required fs-6 fw-bold mb-2">กำไร</label>
                  <!--end::Label-->

                  <!--begin::Input-->
                  <el-form-item prop="markup">
                    <el-input v-model="formModel.markup" />
                  </el-form-item>
                  <!--end::Input-->
                </div>
                <!--end::Col-->

                <!--begin::Col-->
                <div class="col-md-6 fv-row">
                  <!--begin::Label-->
                  <label class="required fs-6 fw-bold mb-2">หน่วย</label>
                  <!--end::Label-->

                  <!--begin::Input-->
                  <el-form-item prop="markupType">
                    <el-select
                      v-model="formModel.markupType"
                      placeholder="เลือกหน่วย"
                    >
                      <el-option
                        v-for="item in markupTypeOptions"
                        :key="item.markupTypeID"
                        :label="item.markupTypeName"
                        :value="item.markupTypeID"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <!--end::Input-->
                </div>
                <!--end::Col-->
              </div>
            </div>
            <!--end::Scroll-->
          </div>
          <!--end::Modal body-->
          <div class="modal-footer">
            <button
              class="btn btn-light-primary me-3"
              type="reset"
              @click="hide"
            >
              กลับ
            </button>
            <button class="btn btn-primary me-3" type="button" @click="submit">บันทึก</button>
          </div>
        </el-form>
      </div>
      <!--begin::Modal content-->
    </div>
    <!--begin::Modal dialog-->
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ApiService from "@/core/services/ApiService";

export default {
  props: {
    partnerCode: String
  },
  data() {
    return {
      formModel: {
        markup: null,
        markupType: null,
      },
      markupTypeOptions: [],
      addMarkupModalRef: null,
      products: [],
      rules: {
        markup: [{ required: true, message: "กรุณาระบุกำไร" }],
        markupType: [{ required: true, message: "เลือกหน่วยกำไร" }],
      },
    };
  },
  mounted() {
    this.addMarkupModalRef = new Modal(this.$refs.addMarkupModalRef);
  },
  methods: {
    hide() {
      this.products = [];
      this.addMarkupModalRef.hide();
    },
    show(products) {
      if (!products) return;

      if (!Array.isArray(products)) {
        this.products = [products];
      } else {
        this.products = products;
      }

      if (this.products[0].markupValue > 0) {
        this.formModel.markup = this.products[0].markupValue;
        this.formModel.markupType = this.products[0].markupTypeID;
      } else {
        this.$refs.markupForm.resetFields();
      }
      this.getMarkupTypeOptions();
      this.addMarkupModalRef.show();
    },
    getMarkupTypeOptions() {
      if (this.markupTypeOptions.length == 0)
        ApiService.get("markups/types").then(
          ({ data }) => (this.markupTypeOptions = data)
        );
    },
    submit: async function () {
      this.$refs.markupForm.validate(async (valid) => {
        // console.log("valid", valid);
        if (!valid) return;

        const loader = this.$loading.show();
        try {
          const productKeys = this.products.map((product) => ({
            productID: product.productID,
            productGrade: product.productGrade,
          }));
          const res = await ApiService.put("partners/" + this.partnerCode + "/markups", {
            markupValue: this.formModel.markup,
            markupTypeID: this.formModel.markupType,
            products: productKeys,

            //this.products.map(product => ({productID: product.productID, productGrade: product.productGrade}))
          });
          const newProductPrices = res.data;
          // console.log(newProductPrices);
          this.products.forEach((product) => {
            const newProduct = newProductPrices.find(
              (p) =>
                product.productID == p.productID &&
                product.productGrade == p.productGrade
            );
            product.markupValue = newProduct.markupValue;
            product.markupTypeID = newProduct.markupTypeID;
            product.markupTypeName = newProduct.markupTypeName;
            product.sellingPrice = newProduct.sellingPrice;
          });

          loader.hide();

          Swal.fire({
            title: "บันทึกสำเร็จ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: true,                  
            allowOutsideClick: false,
            timer: 1500
          });
          this.$emit("refreshdata");
          this.hide();
        } catch (error) {
          console.log(error);
          Swal.fire({
            title: "Error",
            icon: "error",
            text: error.response.data,
            allowOutsideClick: false,            
            timer: 1500
          });
        } finally {
          loader.hide();
        }
      });
    },
  },
};
</script>
